import * as messageService from "../../services/message.service";
import * as taxTableService from '../../services/taxTable.service';


const state = {
    taxTableAll:[],
};

const getters = {
    getTaxTableAll:state => (state.taxTableAll),
};

const actions = {
    async fetchTaxTableAll({ commit } ){
        try {
            const response = await taxTableService.all();

            commit('setTaxTableAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setTaxTableAll:(state, res) => (
        state.taxTableAll =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}